"use client";

var __jsx = React.createElement;
import React, { createContext, useContext, useEffect, useState } from "react";
import { NotificationType } from "types/shared/notification-types";
const NotificationsContext = /*#__PURE__*/createContext(null);
export const NotificationsProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: show,
    1: setShow
  } = useState(false);
  const {
    0: message,
    1: setMessage
  } = useState('');
  const {
    0: type,
    1: setType
  } = useState(NotificationType.INFO);
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShow(false);
      }, 5000);
    }
  }, [show]);
  const notify = (message, type) => {
    setMessage(message);
    setType(type);
    setTimeout(() => {
      setShow(true);
    }, 500);
  };
  return __jsx(NotificationsContext.Provider, {
    value: {
      notify,
      setShow,
      show,
      type,
      message
    }
  }, children);
};
export const useNotifications = () => {
  const context = useContext(NotificationsContext);
  if (context === null) {
    throw new Error("useNotifications must be used within a NotificationsProvider");
  }
  return context;
};